<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad">
                <van-grid class="integral-goods-list" :column-num="2" :gutter="15" border>
					<van-grid-item v-for="(item, index) in goodsList" :key="index" class="integral-goods-item" @click="$router.push({ name:'IntegralGoodsDetail', query : { id : item.id } })">
						<van-image :src="item.images_info[0]['url']" />
						<div class="integral-goods-title">{{item.title}}</div>
						<div class="integral-goods-integral">
							<div class="goods-inline" v-if="item.integral > 0">{{item.integral}}<span>积分</span></div>
							<div class="goods-inline" v-if="item.integral > 0 && item.amount > 0">+</div>
							<div class="goods-inline" v-if="item.amount > 0">{{item.amount}}<span>元</span></div>
						</div>
					</van-grid-item>
                </van-grid>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Index",
        data () {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
                integralGoodsList : [],
            };
        },
        created() {
            this.onRefresh();
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/integral_goods/list', Object.assign({}, self.params)).then(res => {
                    if(self.params.page >= res.data.max_page){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.integralGoodsList = [];
                    }

                    for(let index in res.data.data){
                        self.integralGoodsList.push(res.data.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
        },
		computed : {
			goodsList() {
				return this.integralGoodsList
				return this.integralGoodsList.filter((item) => {
					return item.stock > 0
				})
			}
		}
    }
</script>

<style lang="scss" scoped>
	.goods-inline {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// src/pages/goods/Index.vue